import React from 'react';
import type { LstPeriodView } from './PeriodSwitcher';
import { PeriodSwitcher } from './PeriodSwitcher';
import type { LeaderSelectOption } from './MeuPadraoSubHeader';

export interface MeuPadraoHeaderFiltersProps {
  periodView: LstPeriodView;
  onPeriodChange: (view: LstPeriodView) => void;
  leaderOptions?: LeaderSelectOption[];
  selectedLeaderId?: string;
  onLeaderChange?: (userId: string) => void;
}

/** Controles de líder + período — padrão Meu Padrão (direita do sub-header). */
export const MeuPadraoHeaderFilters = React.memo<MeuPadraoHeaderFiltersProps>(
  function MeuPadraoHeaderFilters({
    periodView,
    onPeriodChange,
    leaderOptions,
    selectedLeaderId,
    onLeaderChange,
  }) {
    const showLeaderSelect = leaderOptions && leaderOptions.length > 1 && onLeaderChange;

    return (
      <div className="flex shrink-0 items-end gap-3">
        {showLeaderSelect && (
          <label className="flex flex-col gap-0.5">
            <span className="text-[9px] font-semibold uppercase tracking-wide text-slate-400">
              Visualizar TPL de
            </span>
            <select
              aria-label="Visualizar TPL de"
              className="h-8 min-w-[148px] rounded-md border border-slate-200 bg-white px-2 text-[12px] text-slate-700 outline-none focus:border-slate-400 dark:border-slate-700 dark:bg-slate-900/60 dark:text-slate-200"
              value={selectedLeaderId ?? leaderOptions[0]?.id ?? ''}
              onChange={(e) => onLeaderChange(e.target.value)}
            >
              {leaderOptions.map((opt) => (
                <option key={opt.id} value={opt.id}>
                  {opt.name}
                </option>
              ))}
            </select>
          </label>
        )}
        <div className="flex flex-col gap-0.5">
          <span className="text-[9px] font-semibold uppercase tracking-wide text-slate-400">Período</span>
          <PeriodSwitcher value={periodView} onChange={onPeriodChange} />
        </div>
      </div>
    );
  },
);

export default MeuPadraoHeaderFilters;
